export const ROOT = '/';
export const JOIN = '/join';
export const ROOM = '/room';
export const HOW_TO = '/how';
export const TOS = '/tos';
export const PATREON = '';
export const BUY_ME_TEA = '';
export const GIT = 'https://github.com/NavIshanOp';